import React from "react"

import { DriveVersionFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchDriveVersion {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: DriveVersionFilters
    onFilter: (filters: DriveVersionFilters) => any
}

const Search = ({
    id = null,
    leftOffset = false,
    rightOffset = false,
    filters = {},
    onFilter = null,
}: SearchDriveVersion) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default Search
